import {
  ANNOUNCEMENTS_IS_LOADING,
  ANNOUNCEMENTS_LOAD_SUCCESS,
  ANNOUNCEMENTS_LOAD_ERROR,
  ANNOUNCEMENTS_DATA_SUCCESS,
} from "../actions/action_types";

export default function settingsReducer(
  state = { announcementsData: {}, isLoading: false, announcementsError: null, items: {}},
  action
) {
  switch (action.type) {
    case ANNOUNCEMENTS_IS_LOADING:
      return { ...state, isLoading: true };
    case ANNOUNCEMENTS_LOAD_SUCCESS:
      return { ...state, announcementsData: action.payload, isLoading: false };
    case ANNOUNCEMENTS_LOAD_ERROR:
      return { ...state, announcementsError: action.payload, isLoading: false };
    case ANNOUNCEMENTS_DATA_SUCCESS:
      return { ...state, items: action.payload, isLoading: false };
    default:
      return state;
  }
}
